import deFlag from '@assets/languages/de.png';
import esFlag from '@assets/languages/es.png';
import frFlag from '@assets/languages/fr.png';
import gbFlag from '@assets/languages/gb.png';
import itFlag from '@assets/languages/it.png';
import ptFlag from '@assets/languages/pt.png';

export enum Languages {
  en = 'en',
  es = 'es',
  it = 'it',
  de = 'de',
  fr = 'fr',
  pt = 'pt'
}

export const LanguageOptions = [
  Languages.en,
  Languages.es,
  Languages.it,
  Languages.de,
  Languages.fr,
  Languages.pt
];

export const CountryFlagLanguageMap = {
  [Languages.en]: gbFlag,
  [Languages.de]: deFlag,
  [Languages.es]: esFlag,
  [Languages.fr]: frFlag,
  [Languages.it]: itFlag,
  [Languages.pt]: ptFlag
};
